// src/components/common/SectionCard.jsx
import React from "react";

function SectionCard({ title, children, className = "" }) {
  return (
    <div className={`bg-white shadow-lg rounded-lg p-6 mb-6 ${className}`}>
      {title && <div className="text-2xl font-semibold mb-4">{title}</div>}
      {children}
    </div>
  );
}

export default SectionCard;